import { render, staticRenderFns } from "./Cpanel.vue?vue&type=template&id=2f301bcd"
import script from "./Cpanel.vue?vue&type=script&lang=js"
export * from "./Cpanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports